module.exports = __webpack_public_path__ + "img/angle_150.442bd6e3.jpg";